import { FC, Fragment } from "react";
import useI18n from "../../../hooks/useTranslations";
import { WallMaterialFixingForSettings } from "../../../http/vertigrip/types/vertigripSettings";
import { getMinutesRoundedTimestamp } from "../../../utils";
import ImageBorderBox from "../../ui/BorderBox";
import ModalDialog from "../../ui/ModalDialog";
import styles from "./WallMaterialsHelpModal.module.css";

type WallMaterialsHelpModalProps = {
  isOpen: boolean;
  onClose: () => void;
  onSelect?: (item: WallMaterialFixingForSettings) => void;
  items: WallMaterialFixingForSettings[];
};

export const WallMaterialsHelpModal: FC<WallMaterialsHelpModalProps> = ({
  items,
  isOpen,
  onClose,
  onSelect,
}: WallMaterialsHelpModalProps) => {
  const i18n = useI18n();

  return (
    <>
      {isOpen && (
        <ModalDialog
          title={i18n.translation.wallMaterials.plural}
          onClose={onClose}
          isSubmitting={false}
          actions={[{ title: i18n.translation.common.close, onClick: onClose }]}
        >
          <div className={styles.small}>
            {items.map((item) => (
              <Fragment key={item.id}>
                <ImageBorderBox
                  onClick={onSelect ? () => onSelect(item) : undefined}
                  showIsMissing={true}
                  title={item.name}
                >
                  <div className={styles.imgSmall}>
                    {item.image ? (
                      <ImageBorderBox.Image
                        src={`${import.meta.env.VITE_BUCKET_URL}${item.image}?${getMinutesRoundedTimestamp()}`}
                      />
                    ) : (
                      ImageBorderBox.PlaceHolder
                    )}
                  </div>
                </ImageBorderBox>
              </Fragment>
            ))}
          </div>
        </ModalDialog>
      )}
    </>
  );
};
